export function isFieldDisabled(value, isRequired: boolean): boolean {
	return Boolean(!isRequired || (isRequired && value || isRequired && value === 0));
}
